import {toWinRate} from './utils';
import Variation from "./variation";

class Prediction {
  constructor() {
    this.key = undefined; // IndexedDB key
    this.date = Date.now();
    this.node = undefined; // node to start prediction
    this.priorProbability = []; // policy output from model.predict()
    this.valueOutput = 0; // value output from model.predict()
    this.visits = []; // visit count of each edge; used for selecting the best move
    this.evaluations = []; // mean evaluation value of each edge
    this.bestMoveIndex = undefined; // best move index
    this.speed = 0;
  }

  get moveNumber() {
    if (!this.node || !this.node.boardModel) {
      return undefined;
    }
    return this.node.boardModel.moveNumber;
  }

  get blackIsNext() {
    if (!this.node || !this.node.boardModel) {
      return true;
    }
    return this.node.boardModel.blackIsNext;
  }

  get winRate() {
    return (1.0 + this.valueOutput) / 2.0 * 100;
  }

  get winRateBlack() {
    return this.blackIsNext ? this.winRate 
      : (100 - this.winRate);
  }

  get variations() {
    const variations = Array(this.visits.length).fill().map(
      (_, i) => {
        const variation = new Variation();
        variation.index = i;
        variation.visit = this.visits[i];
        variation.winRate = toWinRate(this.evaluations[i]);
        return variation;
      });
    variations.sort((a, b) => b.visit - a.visit);
    return variations;
  }
}

export default Prediction;